/* eslint-disable jira/filename-case */
import type { JiraProjectType } from '@jira/platform__project-types/src/project-types.tsx';

export type NavigationProject = {
	isFavourite: boolean;
	projectId: string;
	projectKey: string;
	projectType: JiraProjectType;
};

export type NavigationCollection = {
	collectionUUID: string;
};

export const isNavigationProject = (
	object: NavigationProject | NavigationCollection,
): object is NavigationProject => {
	return 'projectType' in object;
};

export type NavigationContainer = NavigationProject | NavigationCollection;
